//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var EZUIKit;
var ms_ie = false;
var ua = window.navigator.userAgent.toLowerCase();
var old_ie = ua.indexOf("MSIE");
var new_ie = ua.indexOf("trident/");
var is360 = false;
var append = document.getElementById("append");
if (old_ie > -1 || new_ie > -1) {
  EZUIKit = false;
  ms_ie = true;
}
if (window.navigator.appName.indexOf("Microsoft") != -1) {
  me_ie = true;
}
if (window.navigator.mimeTypes[40] || !window.navigator.mimeTypes.length) {
  is360 = true;
}

if (ms_ie) {
  EZUIKit = false;
  var DEFAULT_VERSION = 8.0;
  var ua = navigator.userAgent.toLowerCase();
  var isIE = ua.indexOf("msie") > -1;
  var safariVersion;
  if (isIE) {
    safariVersion = ua.match(/msie ([d.]+)/)[1];
  }
  if (safariVersion <= DEFAULT_VERSION) {
    console.log(
      "系统检测到您正在使用ie8以下内核的浏览器，不能实现完美体验，请更换或升级浏览器访问！"
    );
  }
}
if (EZUIKit != false) {
  EZUIKit = require("@/utils/ezuikit.js");
}
// import EZUIKit from "ezuikit-js";
import axios from "axios";
import store from "@/store";

export default {
  name: "AgrMonitoringVideos",
  data() {
    return {
      visible: this.videoDialog,
      player: "",
      video_Src: "",
      video_Token: "",
      videoInfo: {
        deviceCode: "",
      },
      isTurn: false,
      offWid: "",
      realData: {
        deviceCode: "-",
        deviceName: "-",
        deviceTypeName: "-",
      },
      flag: false,
      EZUIKit: EZUIKit,
    };
  },
  props: {
    videoDialog: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  created() {},
  destroyed() {
    if (this.player) {
      this.player.stop();
      this.player = null;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.stop();
      this.player = null;
    }
  },
  watch: {
    videoDialog() {
      if (this.videoDialog === false || this.videoDialog === null) {
        this.player.stop();
        this.player = null;
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:videoDialog", false);
      this.$emit("flagVideo", false); //弹窗视频关闭 右侧透明栏视频播放
    },
    fn() {
      this.$nextTick(function () {
        if (this.player) {
          this.player = null;
          this.player.stop();
        } else {
          let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
          this.realData = {
            deviceCode: farmAllData.deviceCode,
            deviceName: farmAllData.deviceName,
            deviceTypeName: farmAllData.deviceTypeName,
          };
          this.videoInfo.deviceCode = this.realData.deviceCode;
          var dom = document.querySelector(".box-left");
          this.offWid = dom.offsetWidth;
          let obj = { deviceSerial: this.realData.deviceCode, quality: "1" }; // 1-高清（主码流）、2-流畅（子码流）
          this.$http.agrModel
            .getVideoUrl(obj)
            .then((res) => {
              console.log(res);
              if (res.data.code === "200") {
                console.log("视频接口===", res);
                var that = this;
                this.video_Src = res.data.data.url;
                this.video_Token = res.data.hkystoken;
                this.flag = true;
                console.log(this.video_Src);
                console.log(this.video_Token);
                if (this.EZUIKit) {
                  this.player = new EZUIKit.EZUIKitPlayer({
                    id: "playWind",
                    url: that.video_Src,
                    autoplay: true,
                    accessToken: that.video_Token,
                    // decoderPath: "../../static/EZUIKit-JavaScript/",
                    width: this.offWid,
                    height: 500,
                  });
                } else {
                  this.videoDialog = false;
                  this.$message({
                    message:
                      "该浏览器对于视频监控不能实现完美体验，请更换或升级浏览器访问！",
                    type: "error",
                    customClass: "customClass",
                  });
                }
              } else if (res.code == "20014") {
                this.flag = false;
                this.$message({
                  message: "设备不存在",
                  type: "error",
                  customClass: "customClass",
                });
              } else if (res.code == "20018") {
                this.flag = false;
                this.$message({
                  message: "设备异常，请联系管理员",
                  type: "error",
                  customClass: "customClass",
                });
              } else {
                this.flag = false;
                this.$message({
                  message: "设备不在线",
                  type: "error",
                  customClass: "customClass",
                });
              }
            })
            .catch((err) => {
              console.log(err);
              console.log("视频加载失败");
            });
        }
      });
    },
    ptzControl(num) {
      this.toControl(this.videoInfo, num, 1);
    },

    //控制云台
    toControl(videoInfo, direction, speed) {
      var sta = false;
      if (-1 == direction) {
        this.isTurn = false;
        direction = 2;
        sta = true; //镜头一直转
      }
      if (direction == 111) {
        direction = 2;
        this.isTurn = true;
        this.closeControl(videoInfo);
      }
      let submitData = {
        deviceSerial: videoInfo.deviceCode,
        channelNo: 1,
        direction: direction,
        speed: speed,
      };
      this.$http.agrModel
        .getVideoStatus(submitData)
        .then((responese) => {
          console.log(responese);
          if (responese.status === "1") {
            if (!sta) {
              this.closeControl(videoInfo);
            }
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    //停止云台控制
    closeControl(videoInfo) {
      let submitData = {
        deviceSerial: videoInfo.deviceCode,
        channelNo: 1,
      };
      this.$http.agrModel
        .getVideoStop(submitData)
        .then((responese) => {
          console.log("responese", responese);
          if (responese.status === "1") {
            console.log("关闭成功！");
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    // 拍照
    handleCapture() {
      const loading = this.$loading({
        lock: true,
        text: "正在生成照片，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log("点击了拍照");
      let submitData = {
        deviceSerial: this.videoInfo.deviceCode,
      };
      this.$http.agrModel
        .getPhotograph(submitData)
        .then((responese) => {
          console.log(responese);
          if (responese.status === "1") {
            loading.close();
            this.$message({
              message: "拍照成功",
              type: "success",
              customClass: "customClass",
            });
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    isFullScreen() {
      this.player.fullScreen();
    },
  },
  components: {},
};
